import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  MultipleChoice,
  MultipleChoiceGroup,
  TemplatesApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { ExhaustiveError } from 'src/util/error'
import { TemplateEditMode } from '../../context/TemplateEditMode/TemplateEditMode'
import { getTemplateSpecificQueryOptions } from './useQueryTemplateSpecificMultipleChoices'

/**
 * ひな形限定の選択肢を追加する
 */
export const useMutationAddTemplateSpecificMultipleChoices = (
  templateEditMode: TemplateEditMode,
) => {
  const queryClient = useQueryClient()
  const { queryKey } = getTemplateSpecificQueryOptions(templateEditMode)
  return useMutation({
    mutationFn: async (
      multipleChoices: MultipleChoice[],
    ): Promise<MultipleChoiceGroup> => {
      switch (templateEditMode.mode) {
        case 'edit':
          // 編集モード時はtemplateIdを使用してPOSTリクエストを送信
          return await baseClient
            .getApi(TemplatesApi)
            .addTemplateResponseMultipleChoices({
              templateId: templateEditMode.templateId,
              multipleChoice: multipleChoices,
            })
            .catch(handleHTTPError)
        case 'new':
        case 'newFromPreparedTemplate':
          // 新規作成時は既存のAPI呼び出しを使用
          return await baseClient
            .getApi(TemplatesApi)
            .addResponseMultipleChoices({
              multipleChoice: multipleChoices,
              isTemplateSpecific: true,
            })
            .catch(handleHTTPError)
        default:
          throw new ExhaustiveError(templateEditMode)
      }
    },
    onSuccess: (newGroup: MultipleChoiceGroup) => {
      queryClient.setQueryData<MultipleChoiceGroup[]>(queryKey, (old = []) => [
        ...old,
        newGroup,
      ])
    },
  })
}
